import styled from 'styled-components';

import DriverEditModal from './component';

export default styled(DriverEditModal)`
  .driver-edit-modal {
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &__field {
      width: 100%;
      z-index: 0;

      input {
        height: 38px;
        width: 100%;
      }
    }

    &__section {
      margin-bottom: 0;
      &--dark {
        background-color: var(--grey200);
      }
    }

    &__title {
      color: var(--grey900);
      font-weight: bold;
    }

    &__doc-checkbox {
      display: block;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    &__password-container {
      max-width: 300px;
    }

    &__password-button {
      width: 100%;
    }

    &__password-generated {
      background-color: var(--white);
      border-radius: 6px;
      height: 53px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 6px;
      position: relative;

      > *:last-child {
        position: absolute;
        right: 6px;
      }

      .driver-edit-modal__password {
        font-size: em(20);
        display: block;
        font-family: 'Roboto Slab', serif;
        position: absolute;
        width: 100%;
        text-align: center;
        padding-right: 80px;
      }
    }

    &__banned-field {
      margin: 1rem 0;
      width: 100%;
    }

    &__doc-link {
      padding: 0;
      width: 50%;

      .btnWrapper {
        align-items: flex-start;
        justify-content: flex-start;
      }
    }

    &__footer-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__general-errors {
      background: var(--grey200);
      border: 1px solid var(--grey200);
      color: var(--error700);
      display: flex;
      flex-wrap: wrap;
      margin: -2rem -20px 2rem;
      padding: 0.5rem 3rem;
      width: 680px;
    }

    &__error {
      width: 100%;
    }

    &__delete-btn {
      button {
        color: var(--error700);
        padding: 0;
      }
    }

    &__tag {
      background-color: var(--grey100);
      text-transform: uppercase;
    }

    &__alert-footer {
      display: flex;
      > div {
        flex: 1 auto;
        width: 50%;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__action-button {
      border-width: 1px;
      width: 90%;
      display: block;
      margin: 0 auto;
    }

    &__alert-icon {
      font-size: 4.5rem;
      color: var(--orangePeachText);
    }

    &__alert-body {
      text-align: center;
    }

    .documents-list {
      margin-bottom: 0;
      &__title {
        display: none;
      }
    }
  }
`;
